// extracted by mini-css-extract-plugin
export default {"toggle":"ViewToggle_toggle__u6Uw6","active":"ViewToggle_active__78nHk"};